import React from "react";
import { Search, ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { Input } from "@/shared/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/shared/components/ui/select";
import AdminTransactionTable from "@/shared/components/admin/AdminTransactionTable";

export default function TransactionsTab({
  filteredTxs,
  paginatedTxs,
  page,
  pageSize,
  totalPages,
  txFilters,
  setTxFilters,
  setPage,
  onView,
  txLoading,
  merchants,
  resellers,
  t,
}) {
  return (
    <div className="space-y-4">
      {/* Filters */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-3 bg-white rounded-xl p-4 border border-slate-100">
        <div className="relative md:col-span-2 xl:col-span-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
          <Input
            placeholder={t("searchByIdOrReference")}
            value={txFilters.search}
            onChange={(e) => { setTxFilters({ ...txFilters, search: e.target.value }); setPage(0); }}
            className="pl-10"
          />
        </div>
        <Select value={txFilters.reseller} onValueChange={(v) => { setTxFilters({ ...txFilters, reseller: v }); setPage(0); }}>
          <SelectTrigger className="w-full"><SelectValue placeholder={t("allResellers")} /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t("allResellers")}</SelectItem>
            {resellers.map((r) => <SelectItem key={r.id} value={r.id}>{r.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={txFilters.merchant} onValueChange={(v) => { setTxFilters({ ...txFilters, merchant: v }); setPage(0); }}>
          <SelectTrigger className="w-full"><SelectValue placeholder={t("allMerchants")} /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t("allMerchants")}</SelectItem>
            {merchants.map((m) => <SelectItem key={m.id} value={m.id}>{m.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={txFilters.type} onValueChange={(v) => { setTxFilters({ ...txFilters, type: v }); setPage(0); }}>
          <SelectTrigger className="w-full"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t("allTypes")}</SelectItem>
            <SelectItem value="deposit">{t("deposits")}</SelectItem>
            <SelectItem value="withdrawal">{t("withdrawals")}</SelectItem>
          </SelectContent>
        </Select>
        <Select value={txFilters.status} onValueChange={(v) => { setTxFilters({ ...txFilters, status: v }); setPage(0); }}>
          <SelectTrigger className="w-full"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t("allStatus")}</SelectItem>
            <SelectItem value="pending">{t("pending")}</SelectItem>
            <SelectItem value="processing">{t("processing").replace("...", "")}</SelectItem>
            <SelectItem value="success">{t("success")}</SelectItem>
            <SelectItem value="failed">{t("failed")}</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <AdminTransactionTable
        transactions={paginatedTxs}
        isLoading={txLoading}
        onView={onView}
        merchants={merchants}
        resellers={resellers}
      />

      {totalPages > 1 && (
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs sm:text-sm text-slate-500 text-center sm:text-left">
            {t("showing")} {page * pageSize + 1} {t("to")} {Math.min((page + 1) * pageSize, filteredTxs.length)} {t("of")} {filteredTxs.length}
          </p>
          <div className="flex items-center justify-center gap-2">
            <Button variant="outline" size="sm" className="h-9 w-9 p-0" onClick={() => setPage(page - 1)} disabled={page === 0}>
              <ChevronLeft className="h-4 w-4" />
            </Button>
            <span className="text-xs sm:text-sm text-slate-600">{t("page")} {page + 1} {t("of")} {totalPages}</span>
            <Button variant="outline" size="sm" className="h-9 w-9 p-0" onClick={() => setPage(page + 1)} disabled={page >= totalPages - 1}>
              <ChevronRight className="h-4 w-4" />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
